import { SnackbarProvider as NotistackProvider } from 'notistack';
import { ReactNode } from 'react';

import ErrorSnackbar from './ErrorSnackbar/ErrorSnackbar';
import SuccessSnackbar from './SuccessSnackbar/SuccessSnackbar';

interface Props {
  children: ReactNode;
}

const SnackbarProvider: React.FC<Props> = ({ children }) => {
  return (
    <NotistackProvider
      autoHideDuration={3000}
      preventDuplicate
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      Components={{
        error: ErrorSnackbar,
        success: SuccessSnackbar,
      }}>
      {children}
    </NotistackProvider>
  );
};

export default SnackbarProvider;
